import { render } from "./Snackbar.vue?vue&type=template&id=ddbc36de&scoped=true&lang=pug"
import script from "./Snackbar.vue?vue&type=script&lang=ts"
export * from "./Snackbar.vue?vue&type=script&lang=ts"

import "./Snackbar.vue?vue&type=style&index=0&id=ddbc36de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ddbc36de"

export default script